<template>
    <div>
        <el-dialog :visible.sync="offlineDetailDialog" width="60%" top="13vh" center style="border: 1px solid #01DFD7" :close-on-click-modal = false
               :close-on-press-escape = false v-loading="loading"  element-loading-text="请求处理中" element-loading-spinner="el-icon-loading"  
               element-loading-background="rgba(0.8, 0, 0, 0.3)" @close="closeDialog">
            <el-card style="height: 560px">
                <el-tabs type="border-card" v-model="activceName">
                    <el-tab-pane label="通道信息" name="1">
                        <el-form ref="dateForm" label-width="128px" label-position="left"> 
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="充电柜编号">{{response.data.powerBoxId}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="微码编号">{{response.data.imei}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="物联网卡号">{{response.data.iccid}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="物联网卡同步时间">{{response.data.iccidTime}}</el-form-item>
                                </el-col>
                            </el-row> 
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="当前在/离线状态">{{response.data.stateStr}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="持续时间">{{response.data.continueStr}}</el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="最后一次在线时间">{{response.data.lastOnlineTime}}</el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="最后一次离线时间">{{response.data.lastOfflineTime}}</el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="通道历史记录" name="2">
                         <el-table :data="response.data.deviceOfflineHisDtoList"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" 
                                   style="margin:auto;width:calc(100% - 30px)" height="450" border :row-style="{ height: '0.3%' }" :cell-style="{ padding: '0.25%' }"
                                   :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
                            <el-table-column label="操作批次" align="center" prop="id" width="200"  v-if="false"></el-table-column>
                            <el-table-column label="充电柜编号" align="center" prop="powerBoxIdHis"></el-table-column>
                            <el-table-column label="在/离线状态" align="center" prop="stateStrHis"></el-table-column>
                            <el-table-column label="时间" align="center" width="180">
                                <template slot-scope="scope">{{ scope.row.timeHis | formatDate}}</template>
                            </el-table-column>
                        </el-table>
                        <el-pagination :current-page="query.current" :total="response.total" @current-change="currenChangeHandle" layout="total, prev, pager, next, jumper" :page-size="query.size"/>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-dialog>
    </div>
</template>
<script>
import {getDeviceOfflineById} from "../../../api/warehousedevice/warehousedevice.js";
import { formatDate } from "../../../utils/date.js";
export default {
    data() {
        return {
            response: {data: [],total: 0},
            query: {current: 1, size: 50},
            loading: false,
            offlineDetailDialog: false,
            activceName: "1",
            deviceId: null
        }
    },
    methods: {
        init(deviceId){
            this.offlineDetailDialog = true;
            this.deviceId = deviceId;
            getDeviceOfflineById({current: this.query.current,size: this.query.size},deviceId).then(result=>{
                this.response.data = result.data.records[0];
                this.response.total = result.data.total;
            })
        },
        currenChangeHandle(value){
            this.query.current = value;
            this.init(this.deviceId);
        },

        /**
         * 关闭弹窗
         */
        closeDialog(){
            this.activceName = "1";
            this.response.data = ''
        } 
    },
    filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
  },
}
</script>
<style scoped>
.el-pagination{
    margin-left: 30%;
}
</style>


// WEBPACK FOOTER //
// src/pages/warehouse/warehousedevice/offlinedetail.vue